import { render, staticRenderFns } from "./ServiceAdd.vue?vue&type=template&id=af4537d6&scoped=true"
import script from "./ServiceAdd.vue?vue&type=script&lang=js"
export * from "./ServiceAdd.vue?vue&type=script&lang=js"
import style0 from "./ServiceAdd.vue?vue&type=style&index=0&id=af4537d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af4537d6",
  null
  
)

export default component.exports